<template>
  <Button
    class="float p-button-rounded p-button-lg p-shadow-5"
    :icon="icon"
    :style="{ width: '56px', height: '56px' }"
  />
</template>

<script>
export default {
  name: 'AppFloatButton',
  props: {
    icon: String,
  },
};
</script>

<style scoped>
.float {
  position: fixed;
  bottom: 1em;
  right: .8em;
  z-index: 1000;
}
@media (min-width: 600px) {
  .float {
    right: 1.5em;
  }
}
</style>